import { Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import { styled } from 'styled-components';

import downArrow from 'src/resources/arrow-down.svg';
import { breakpointLargeTablet, breakpointTablet } from 'src/styles/breakpoints';
import { colorNeutral800 } from 'src/styles/colors';
import { fontPrimary } from 'src/styles/fonts';
import { spacing1, spacing2 } from 'src/styles/spacing';

export const StyledDropdown = styled.select`
  appearance: none;
  height: 44px;
  border: 0;
  box-shadow:
    1px 1px 1px rgba(0 0 0 / 10%),
    0 1px 2px rgba(0 0 0 / 15%),
    1px 1px 4px rgba(0 0 0 / 25%),
    0 2px 8px rgba(0 0 0 / 10%);
  border-radius: 2px;
  cursor: pointer;
  font-family: ${fontPrimary};
  font-size: 16px;
  color: ${colorNeutral800};
  padding: 10px 16px;
  background: url('${downArrow}') no-repeat right center;
  background-size: 20px;
  background-position-x: calc(100% - ${spacing2});

  @media (min-width: ${breakpointTablet}) {
    height: 48px;
    font-size: 18px;
    padding: 12px 16px;
    background-size: 20px;
  }

  @media (min-width: ${breakpointLargeTablet}) {
    height: 56px;
    padding: 17px 16px 15px;
    font-size: 20px;
    background-size: 24px;
  }
`;

export const StyledDropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledLabel = styled(Typography)`
  font-weight: bold;
  margin-bottom: ${spacing1};
`;
